export function axIsTypeString(x) {
    return typeof x === 'string';
}
